import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { StorageKeys, Error, ErrorCodes } from 'src/app/utils/common-classes';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../Auth/auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  private language: string;
  private loading: boolean = false;
  private dialogUnclosable: boolean = false;

  constructor(
    private router: Router,
    public snackBar: MatSnackBar,
    private translate: TranslateService,
    private authService: AuthService) {
    let language = localStorage.getItem(StorageKeys.LANGUAGE);
    if (language) {
      this.language = language;
    } else {
      this.language = "it";
    }
  }

  public showShortLoader(): void {
    this.loading = true;
    document.body.classList.add('loading');
  }

  public hideShortLoader(): void {
    this.loading = false;
    document.body.classList.remove('loading');
  }

  public setDialogUnclosable(dialogUnclosable: boolean): void {
    this.dialogUnclosable = dialogUnclosable;
  }

  public showToast(message: string): void {
    this.snackBar.open(message, "OK", { duration: 5000, panelClass: ["success-toast"] });
  }

  public showErrorToast(message: string): void {
    this.snackBar.open(message, "OK", { duration: 5000, panelClass: ["error-toast"] });
  }

  public waitMilliseconds(ms): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public translateKey(key: string): Promise<string> {
    let _self = this;
    return new Promise((resolve, reject) => {
      _self.translate.get(key).subscribe((value: string) => {
        resolve(value)
      });
    });
  }

  public translateKeyWithData(key: string, data: Object): Promise<string> {
    let _self = this;
    return new Promise((resolve, reject) => {
      _self.translate.get(key, data).subscribe((value: string) => {
        resolve(value)
      });
    });
  }

  private getErrorKey(error: string): string {
    let errorKey: string = "general.error.unknown-error";
    switch (error) {
      case ErrorCodes.INVALID_PATH:
        errorKey = "general.error.invalid-path";
        break;
      case ErrorCodes.MISSING_REQUIRED_DATA:
        errorKey = "general.error.missing-required-data";
        break;
      case ErrorCodes.INVALID_SERVICE:
        errorKey = "general.error.invalid-service";
        break;
      case ErrorCodes.INVALID_FOLDER_NAME:
        errorKey = "general.error.invalid-folder-name";
        break;
      case ErrorCodes.DUPLICATE_FILE_NAME:
        errorKey = "general.error.duplicate-file-name";
        break;
      case ErrorCodes.DUPLICATE_FOLDER_NAME:
        errorKey = "general.error.duplicate-folder-name";
        break;
      case ErrorCodes.PARENT_FOLDER_NOT_FOUND:
        errorKey = "general.error.parent-folder-not-found";
        break;
      case ErrorCodes.DESTINATION_IS_SUBFOLDER:
        errorKey = "general.error.destination-is-subfolder";
        break;
      case ErrorCodes.USER_NOT_FOUND:
        errorKey = "general.error.user-not-found";
        break;
      case ErrorCodes.FILE_NOT_FOUND:
        errorKey = "general.error.file-not-found";
        break;
      case ErrorCodes.FOLDER_NOT_FOUND:
        errorKey = "general.error.folder-not-found";
        break;
      case ErrorCodes.TREE_NOT_FOUND:
        errorKey = "general.error.tree-not-found";
        break;
      case ErrorCodes.SESSION_NOT_FOUND:
        errorKey = "general.error.session-not-found";
        break;
      case ErrorCodes.DUPLICATE_TREE_NAME:
        errorKey = "general.error.duplicate-tree-name";
        break;
      case ErrorCodes.UNKNOWN_ERROR:
        errorKey = "general.error.unknown-error";
        break;
      case ErrorCodes.CONNECTION_REFUSED:
        errorKey = "general.error.connection-refused";
        break;
      case ErrorCodes.LOAD_PREVIEW_ERROR:
        errorKey = "general.error.load-preview-error";
        break;
    }
    return errorKey;
  }

  public getErrorShowToast(error: any): Promise<void> {
    let _self = this;
    return new Promise<void>((resolve, reject) => {
      _self.getError(error).then((translatedError: string) => {
        if (translatedError) {
          _self.showErrorToast(translatedError);
        }
        resolve();
      })
    });
  }

  public getError(error: any): Promise<string> {
    let _self = this;
    return new Promise<string>((resolve, reject) => {
      let errorKey: string = "general.error.unknown-error";
      if (error) {
        if (error.status == 0) {
          errorKey = _self.getErrorKey(ErrorCodes.CONNECTION_REFUSED);
          _self.translateKey(errorKey).then((translatedKey: string) => {
            resolve(translatedKey);
          });
        } else if (error.error) {
          let errorObject = error.error;
          if (typeof (errorObject) === "string") {
            //è una string converto
            if (errorObject == ErrorCodes.SESSION_NOT_FOUND) {
              _self.authService.logout().then(() => {
                errorKey = _self.getErrorKey(errorObject);
                return _self.router.navigate(['login']);
              }).then(() => {
                return _self.translateKey(errorKey);
              }).then((translatedKey: string) => {
                //mostro il toaster di errore session scaduta SEMPRE
                _self.showErrorToast(translatedKey);
                //ritorno null per non mostrare 2 volte il toster
                resolve(null);
              });
            } else {
              errorKey = _self.getErrorKey(errorObject);
              _self.translateKey(errorKey).then((translatedKey: string) => {
                resolve(translatedKey);
              });
            }
          } else if (errorObject.error && typeof (errorObject.error) === "string") {
            if (errorObject.error == ErrorCodes.SESSION_NOT_FOUND) {
              _self.authService.logout().then(() => {
                errorKey = _self.getErrorKey(errorObject.error);
                return _self.router.navigate(['login']);
              }).then(() => {
                return _self.translateKey(errorKey);
              }).then((translatedKey: string) => {
                //mostro il toaster di errore session scaduta SEMPRE
                _self.showErrorToast(translatedKey);
                //ritorno null per non mostrare 2 volte il toster
                resolve(null);
              });
            } else {
              errorKey = _self.getErrorKey(errorObject.error);
              _self.translateKey(errorKey).then((translatedKey: string) => {
                resolve(translatedKey);
              });
            }


          } else if (errorObject.message && typeof (errorObject.message) === "string") {
            resolve(errorObject.message);
          } else {
            _self.translateKey(errorKey).then((translatedKey: string) => {
              resolve(translatedKey);
            });
          }
        } else {
          _self.translateKey(errorKey).then((translatedKey: string) => {
            resolve(translatedKey);
          });
        }
      } else {
        _self.translateKey(errorKey).then((translatedKey: string) => {
          resolve(translatedKey);
        });
      }
    });
  }

  public getLanguage(): string {
    return this.language;
  }

  public setLanguage(language: string): void {
    let _self = this;
    _self.language = language;
    localStorage.setItem(StorageKeys.LANGUAGE, language);
    _self.translate.use(language);
  }

  public isLoading(): boolean {
    return this.loading;
  }

  public isDialogUnclosable(): boolean {
    return this.dialogUnclosable;
  }

}
